import React, { Component } from 'react'
import { connect } from 'react-redux';
import { getTrainingApply } from '../actions/MainAction';
import BigCard from '../components/BigCard';
export class TrainingApply extends Component {

    componentDidMount(){
        this.props.getTrainingApply()
    }
  render() {
    const {trainingApply} = this.props;
    // console.log(trainingApply)
    return (
      <div className='container ml-auto mr-auto'>
        {
            trainingApply.map((data, i)=>{
                return(
                   <BigCard 
                    key={i}
                    name={data?.first_name}
                    lastName={data?.last_name}
                    email={data?.email}
                    phone_number={data?.phone_number}
                    desc={data?.text}
                    training={data?.training?.title}
                    option={data?.options}
                   />
                )
            })
        }
      </div>
    )
  }
}
const mapStateToProps  = (state) =>({
    trainingApply: state.Data.trainingApply
});
const mapDispatchToProps = {getTrainingApply}
export default connect(mapStateToProps, mapDispatchToProps)(TrainingApply)


